import axios from 'axios';
import { auth } from '../utils/requests';
import { request_mutations, request_state } from '../utils/store';
import { ASSIGNEE_LIST, ASSIGNEE_DETAIL } from '../api';

export default {
    namespaced: true,
    state: {
        create: request_state(),
        remove: request_state(),
    },
    mutations: {
        ...request_mutations('create', 'create'),
        ...request_mutations('remove', 'remove'),
    },
    actions: {
        create({ commit }, {
            space_id, flow_id, card_id, user_id,
        }) {
            const url = ASSIGNEE_LIST
                .replace('{space_id}', space_id)
                .replace('{flow_id}', flow_id)
                .replace('{card_id}', card_id);

            commit('create_loading');
            return new Promise((resolve) => {
                axios.post(url, { user: user_id }, auth()).then((response) => {
                    commit('create_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('create_error', error.response ? error.response.data : {});
                });
            });
        },
        remove({ commit }, {
            space_id, flow_id, card_id, assignee_id,
        }) {
            const url = ASSIGNEE_DETAIL
                .replace('{space_id}', space_id)
                .replace('{flow_id}', flow_id)
                .replace('{card_id}', card_id)
                .replace('{assignee_id}', assignee_id);

            commit('remove_loading');
            return new Promise((resolve) => {
                axios.delete(url, auth()).then((response) => {
                    commit('remove_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('remove_error', error.response ? error.response.data : {});
                });
            });
        },
    },
};
